// ─── Admin Dashboard Mock Data ───

export const adminStats = {
  todayBookings: 12,
  weekBookings: 87,
  monthBookings: 342,
  totalPatients: 2847,
  totalDoctors: 8,
  totalServices: 24,
  totalPackages: 6,
  pendingBookings: 5,
  unreadMessages: 3,
  revenueThisMonth: 128500,
  revenueLastMonth: 114200,
  revenueGrowth: 12.5,
  visitorsToday: 456,
  visitorsGrowth: 8.3,
  satisfactionRate: 96.4,
  avgSessionMin: 4.2,
  newPatientsThisMonth: 134,
  returningPatients: 208,
  cancelledBookings: 7,
  completedBookings: 330,
};

export const recentBookings = [
  {
    id: "BK-2026-001",
    patientName: "أحمد محمد",
    service: "استشارة جلدية",
    doctor: "د. سارة العلي",
    date: "2026-04-23",
    time: "10:00 ص",
    status: "confirmed",
    phone: "+966 50 123 4567",
    avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20man%20portrait%20headshot%20neutral%20background%20clean%20modern%20style&width=60&height=60&seq=p1&orientation=squarish",
  },
  {
    id: "BK-2026-002",
    patientName: "فاطمة الزهراء",
    service: "تجميل ليزر",
    doctor: "د. خالد السالم",
    date: "2026-04-23",
    time: "11:30 ص",
    status: "pending",
    phone: "+966 55 987 6543",
    avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20woman%20portrait%20headshot%20neutral%20background%20clean%20modern%20style%20hijab&width=60&height=60&seq=p2&orientation=squarish",
  },
  {
    id: "BK-2026-003",
    patientName: "محمد عبدالله",
    service: "فحص شامل",
    doctor: "د. نورة الفهد",
    date: "2026-04-23",
    time: "14:00 م",
    status: "confirmed",
    phone: "+966 54 456 7890",
    avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20young%20man%20portrait%20headshot%20neutral%20background%20clean%20modern%20style&width=60&height=60&seq=p3&orientation=squarish",
  },
  {
    id: "BK-2026-004",
    patientName: "نورة السعيد",
    service: "علاج بالخلايا",
    doctor: "د. سارة العلي",
    date: "2026-04-24",
    time: "09:00 ص",
    status: "pending",
    phone: "+966 56 789 0123",
    avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20woman%20portrait%20headshot%20neutral%20background%20warm%20smile%20clean%20modern%20style&width=60&height=60&seq=p4&orientation=squarish",
  },
  {
    id: "BK-2026-005",
    patientName: "عبدالرحمن فهد",
    service: "استشارة تغذية",
    doctor: "د. خالد السالم",
    date: "2026-04-24",
    time: "16:00 م",
    status: "confirmed",
    phone: "+966 53 234 5678",
    avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20man%20portrait%20headshot%20neutral%20background%20confident%20smile%20clean%20modern%20style&width=60&height=60&seq=p5&orientation=squarish",
  },
  {
    id: "BK-2026-006",
    patientName: "ريم الحربي",
    service: "تقشير كيميائي",
    doctor: "د. سارة العلي",
    date: "2026-04-24",
    time: "11:00 ص",
    status: "cancelled",
    phone: "+966 57 345 6789",
    avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20woman%20portrait%20headshot%20neutral%20background%20clean%20modern%20style&width=60&height=60&seq=p6&orientation=squarish",
  },
];

export const recentMessages = [
  {
    id: "MSG-001",
    name: "ليلى أحمد",
    email: "laila@example.com",
    subject: "استفسار عن باقة العائلة",
    message: "أريد معرفة تفاصيل باقة العائلة الشاملة وهل تشمل الأطفال؟",
    date: "2026-04-23",
    time: "09:15 ص",
    isRead: false,
    avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20woman%20portrait%20headshot%20neutral%20background%20clean%20modern%20style%20hijab&width=60&height=60&seq=m1&orientation=squarish",
  },
  {
    id: "MSG-002",
    name: "خالد العمر",
    email: "khaled@example.com",
    subject: "موعد طارئ",
    message: "هل يمكن الحصول على موعد طارئ اليوم؟ أعاني من ألم شديد.",
    date: "2026-04-23",
    time: "08:30 ص",
    isRead: false,
    avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20man%20portrait%20headshot%20neutral%20background%20clean%20modern%20style&width=60&height=60&seq=m2&orientation=squarish",
  },
  {
    id: "MSG-003",
    name: "سارة محمد",
    email: "sara@example.com",
    subject: "شكر وتقدير",
    message: "شكراً لفريقكم الرائع على الخدمة المتميزة في زيارتي الأخيرة.",
    date: "2026-04-22",
    time: "18:45 م",
    isRead: true,
    avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20woman%20portrait%20headshot%20neutral%20background%20warm%20smile%20clean%20modern%20style&width=60&height=60&seq=m3&orientation=squarish",
  },
  {
    id: "MSG-004",
    name: "عمر الرشيد",
    email: "omar@example.com",
    subject: "تغيير موعد",
    message: "أرغب في تغيير موعدي من الثلاثاء إلى الأربعاء إن أمكن.",
    date: "2026-04-22",
    time: "14:10 م",
    isRead: true,
    avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20man%20portrait%20headshot%20neutral%20background%20calm%20expression%20clean%20modern%20style&width=60&height=60&seq=m4&orientation=squarish",
  },
];

export const chartData = {
  bookingsByMonth: [
    { month: "يناير", bookings: 245, revenue: 98000 },
    { month: "فبراير", bookings: 278, revenue: 112000 },
    { month: "مارس", bookings: 310, revenue: 125000 },
    { month: "أبريل", bookings: 342, revenue: 128500 },
  ],
  bookingsByService: [
    { service: "استشارة جلدية", count: 89, color: "#2E4E45" },
    { service: "تجميل ليزر", count: 67, color: "#C8A96E" },
    { service: "فحص شامل", count: 54, color: "#4A7C6F" },
    { service: "علاج بالخلايا", count: 43, color: "#D4B896" },
    { service: "استشارة تغذية", count: 38, color: "#6B9E94" },
    { service: "أخرى", count: 51, color: "#A8C5BF" },
  ],
  visitorsByDay: [
    { day: "السبت", visitors: 320 },
    { day: "الأحد", visitors: 410 },
    { day: "الإثنين", visitors: 380 },
    { day: "الثلاثاء", visitors: 456 },
    { day: "الأربعاء", visitors: 390 },
    { day: "الخميس", visitors: 340 },
    { day: "الجمعة", visitors: 280 },
  ],
  revenueByMonth: [
    { month: "يناير", revenue: 98000 },
    { month: "فبراير", revenue: 112000 },
    { month: "مارس", revenue: 125000 },
    { month: "أبريل", revenue: 128500 },
  ],
};

export const topDoctors = [
  {
    id: "d1",
    name: "د. سارة العلي",
    specialty: "جلدية وتجميل",
    bookings: 124,
    rating: 4.9,
    avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20female%20doctor%20portrait%20white%20coat%20neutral%20background%20confident%20smile%20clean%20modern%20style&width=80&height=80&seq=dr1&orientation=squarish",
    growth: 14,
  },
  {
    id: "d2",
    name: "د. خالد السالم",
    specialty: "ليزر وتجميل",
    bookings: 98,
    rating: 4.8,
    avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20male%20doctor%20portrait%20white%20coat%20neutral%20background%20confident%20smile%20clean%20modern%20style&width=80&height=80&seq=dr2&orientation=squarish",
    growth: 9,
  },
  {
    id: "d3",
    name: "د. نورة الفهد",
    specialty: "تغذية علاجية",
    bookings: 76,
    rating: 4.7,
    avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20female%20doctor%20portrait%20white%20coat%20neutral%20background%20warm%20smile%20clean%20modern%20style%20hijab&width=80&height=80&seq=dr3&orientation=squarish",
    growth: 6,
  },
  {
    id: "d4",
    name: "د. عمر الحسن",
    specialty: "خلايا جذعية",
    bookings: 61,
    rating: 4.9,
    avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20male%20doctor%20portrait%20white%20coat%20neutral%20background%20calm%20expression%20clean%20modern%20style&width=80&height=80&seq=dr4&orientation=squarish",
    growth: 18,
  },
];

export const todaySchedule = [
  { time: "09:00 ص", patient: "أحمد محمد", service: "استشارة جلدية", doctor: "د. سارة العلي", status: "completed" },
  { time: "10:00 ص", patient: "فاطمة الزهراء", service: "تجميل ليزر", doctor: "د. خالد السالم", status: "in_progress" },
  { time: "11:30 ص", patient: "محمد عبدالله", service: "فحص شامل", doctor: "د. نورة الفهد", status: "upcoming" },
  { time: "13:00 م", patient: "نورة السعيد", service: "علاج بالخلايا", doctor: "د. عمر الحسن", status: "upcoming" },
  { time: "14:30 م", patient: "عبدالرحمن فهد", service: "استشارة تغذية", doctor: "د. نورة الفهد", status: "upcoming" },
  { time: "16:00 م", patient: "ريم الحربي", service: "تقشير كيميائي", doctor: "د. سارة العلي", status: "upcoming" },
];

export const systemNotifications = [
  { id: "n1", type: "booking", message: "حجز جديد من أحمد محمد — استشارة جلدية", time: "منذ 5 دقائق", isRead: false },
  { id: "n2", type: "message", message: "رسالة جديدة من ليلى أحمد — استفسار عن الباقات", time: "منذ 12 دقيقة", isRead: false },
  { id: "n3", type: "cms", message: "تم تحديث محتوى الصفحة الرئيسية بواسطة خالد العتيبي", time: "منذ 45 دقيقة", isRead: false },
  { id: "n4", type: "booking", message: "تم إلغاء حجز ريم الحربي", time: "منذ ساعة", isRead: true },
  { id: "n5", type: "system", message: "تم تسجيل دخول مستخدم جديد: نورة الشمري", time: "منذ ساعتين", isRead: true },
];

export const adminUser = {
  name: "مدير النظام",
  email: "admin@clinic.com",
  role: "super_admin",
  avatar: "https://readdy.ai/api/search-image?query=professional%20arab%20business%20man%20portrait%20headshot%20neutral%20background%20confident%20smile%20clean%20modern%20style&width=100&height=100&seq=admin1&orientation=squarish",
  lastLogin: "2026-04-23 08:30",
};
